import { useIntl } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'
import BodyText from 'LuxKit/Typography/BodyText'
import type { FlightSortOptions } from 'constants/flight'
import ChatFlightSortDropdown from './ChatFlightSortDropdown'

const FlightResultsHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${rem(8)};
`

const FlightResultsHeaderLabel = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(8)};
  min-width: 0;
`

interface Props {
  label: string
  count: number
  sort: FlightSortOptions
  originAirportCode?: string
  destinationAirportCode?: string
  onSortChange: (sort: FlightSortOptions) => void
}

function ChatFlightResultsHeader(props: Props) {
  const {
    label,
    count,
    sort,
    originAirportCode,
    destinationAirportCode,
    onSortChange,
  } = props
  const intl = useIntl()

  return (
    <FlightResultsHeaderContainer>
      <FlightResultsHeaderLabel>
        <BodyText variant="medium" weight="bold">
          {label}
        </BodyText>
        <BodyText variant="medium" colour="light-foreground-alt">
          {intl.formatMessage(
            {
              id: 'nEoq4tHJdg-80Jz3c84T',
              defaultMessage: '{count, plural, one {# flight found} other {# flights found}}',
              description: 'Flight result count shown beside the segment label in the trip planner chat flight widget',
            },
            { count },
          )}
        </BodyText>
      </FlightResultsHeaderLabel>
      <ChatFlightSortDropdown
        sort={sort}
        originAirportCode={originAirportCode}
        destinationAirportCode={destinationAirportCode}
        onChange={onSortChange}
      />
    </FlightResultsHeaderContainer>
  )
}

export default ChatFlightResultsHeader
